export function formatDate(date : Date) : string {
    const year = date.getFullYear();
    const month = date.getMonth()+1;
    const day = date.getUTCDate();
    return year +'-'+month+'-'+day;
}